import { useOrdersStore } from '~/store/orders';

export default function useReturnsRouting() {
  const store = useOrdersStore();

  return {
    async next() {
      const email = store.currentOrder.customerEmail;
      const ref = store.currentOrder.orderNumber;

      if (process.client) {
        window.location.replace(`${store.returnsUrl}#?ref=${ref}&email=${email}`);
      }
    },

    start() {
      navigateTo('/process');
    },

    validate() {
      return this.start();
    },
  };
}
